import { connect } from 'react-redux'
import {
  accessListSelector,
  sidebarDragSelector
} from '../../../../store/selectors/accessSelectors'

export default connect((state) => {
  const dragging = sidebarDragSelector(state)
  if(!dragging) return {}
  // TODO don't render if !dragging
  return {
    x: Math.round(dragging.x),
    y: Math.round(dragging.y),
    item: accessListSelector(state)[dragging.id]
  }
})
